/** Header names for the per-request UMK-proof (parent spec §8). */
export const UMK_PROOF_HEADER = 'x-umk-proof';
export const UMK_NONCE_HEADER = 'x-umk-nonce';
//# sourceMappingURL=api.js.map